(function ($) {
  Drupal.behaviors.sppOlapicV1 = {
    attach: function (context) {
      var $template = $('.js-spp-olapic--v1', context);
      var minItems = 8; // minimum amount of items in order to show olapic content block

      // Need to wait for Olapic carousel widget to finish rendering
      $(window).on('load', function () {
        setTimeout(function () {
          var $items = $template.find('.olapic-wall > li , .olapic-carousel > li');
          var totalItems = $items.length;
          // trigger window.resize event
          // needed to update olapic packery container since we're intially hiding it
          var fireRefreshEventOnWindow = function () {
            var evt = document.createEvent('HTMLEvents');

            evt.initEvent('resize', true, false);
            window.dispatchEvent(evt);
          };

          if (totalItems >= minItems) {
            $template.addClass('active');
            fireRefreshEventOnWindow();
          }
        }, 1000);
      });
    }
  };
})(jQuery);
